import { render, staticRenderFns } from "./TechnologyService.vue?vue&type=template&id=0f95e124&scoped=true"
import script from "./TechnologyService.vue?vue&type=script&lang=js"
export * from "./TechnologyService.vue?vue&type=script&lang=js"
import style0 from "./technologyService.css?vue&type=style&index=0&id=0f95e124&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f95e124",
  null
  
)

export default component.exports